// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface TenantInfo {
  readonly code: string;
  readonly name: string;
  readonly id: string;
}

export interface AppInfo {
  readonly name: string;
  readonly displayName?: string;
}

interface PlatformState {
  currentTenant: string;
  currentCountry: string | null;
  currentCurrency: string | null;
  currentApp: string;
  tenants: TenantInfo[];
  apps: AppInfo[];
  setTenant: (code: string) => void;
  setTenantContext: (payload: { code: string; countryCode?: string | null; currency?: string | null }) => void;
  setApp: (name: string) => void;
  setTenants: (list: TenantInfo[]) => void;
  setApps: (list: AppInfo[]) => void;
}

export const usePlatformStore = create<PlatformState>()(
  persist(
    (set) => ({
      currentTenant: 'default',
      currentCountry: null,
      currentCurrency: null,
      currentApp: 'smarterp',
      tenants: [],
      apps: [],
      setTenant: (code) => set({ currentTenant: code }),
      setTenantContext: ({ code, countryCode, currency }) =>
        set({ currentTenant: code, currentCountry: countryCode ?? null, currentCurrency: currency ?? null }),
      setApp: (name) => set({ currentApp: name }),
      setTenants: (list) => set({ tenants: list }),
      setApps: (list) => set({ apps: list }),
    }),
    {
      name: 'elpo-core-context',
      version: 2,
      // v1'de currentApp varsayılanı 'hello' (örnek app) kalmıştı; gerçek app smarterp.
      // Eski persist'li 'hello' kullanıcılarını da düzelt (yoksa /api/{tenant}/hello/... 404).
      migrate: (persisted, version) => {
        const s = (persisted ?? {}) as { currentApp?: string };
        if (version < 2 && (!s.currentApp || s.currentApp === 'hello')) {
          s.currentApp = 'smarterp';
        }
        return s as unknown as PlatformState;
      },
    },
  ),
);
